import type { AxiosInstance } from 'axios'
import URI from 'urijs'

import { BlogListInterface } from '../../interfaces/blog'
import { Pagination } from '../../interfaces/common'

export const getBlogList = (api: AxiosInstance) => (
  page = 1,
  limit?: number,
  sortBy?: string,
  sortDirection?: string,
  q?: string
): Promise<Pagination<BlogListInterface>> =>
  api.get(
    '/v1.0/admin/blogs?' +
      URI.buildQuery({
        page,
        limit,
        sortBy,
        sortDirection,
        keyword: q
      })
  )
